<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>ZigZag Heading And Alternate CTA</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
          ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event,'ZigZagHaacImage')"
            [blockData]="block.variables?.ZigZagHaacImage ?? ''"
            [placeholder]="imagePlaceholder"
            variable="ZigZagHaacImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event,'ZigZagHaacHeading')"
            [blockData]="block.variables?.ZigZagHaacHeading ?? ''"
            [placeholder]="headingPlaceholder"
            variable="ZigZagHaacHeading"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event,'ZigZagHaacImageHref')"
            [blockData]="block.variables?.ZigZagHaacImageHref ?? ''"
            [placeholder]="imageHrefPlaceholder"
            variable="ZigZagHaacImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagHaacImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.ZigZagHaacImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [maxLength]="500"
            [type]="'alt'"
            (handleOnChange)="onChange($event,'ZigZagHaacImageAlt')"
            [blockData]="block.variables?.ZigZagHaacImageAlt ?? ''"
            [placeholder]="imageAltPlaceholder"
            variable="ZigZagHaacImageAlt"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event,'ZigZagHaacCtaLink')"
            [blockData]="block.variables?.ZigZagHaacCtaLink ?? ''"
            [placeholder]="ctaLinkPlaceholder"
            variable="ZigZagHaacCtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagHaacCtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.ZigZagHaacCtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event,'ZigZagHaacCtaText')"
            [blockData]="block.variables?.ZigZagHaacCtaText ?? ''"
            [placeholder]="ctaTextPlaceholder"
            variable="ZigZagHaacCtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event,'ZigZagHaacText')"
            [blockData]="block.variables?.ZigZagHaacText ?? ''"
            [placeholder]="textPlaceholder"
            variable="ZigZagHaacText"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div *ngIf="block.variables?.ZigZagHaacImage" class="col-6">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.ZigZagHaacImageHref))"
            ><img
              [src]="$safeNavigationMigration(block.variables?.ZigZagHaacImage)"
              class="img-fluid"
              [alt]="$safeNavigationMigration(block.variables?.ZigZagHaacImageAlt)"
            /></a>
          </div>
          <div class="col-6">
            <div class="row text-center">
              <div
                class="col-12"
                [innerHTML]="$safeNavigationMigration(block.variables?.ZigZagHaacHeading)"
              ></div>
              <div
                class="col-12"
                [innerHTML]="$safeNavigationMigration(block.variables?.ZigZagHaacText)"
              ></div>
              <div
                *ngIf="block.variables?.ZigZagHaacCtaText"
                class="col-12 mt-3"
              >
                <a
                  target="_blank"
                  class=""
                  [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.ZigZagHaacCtaLink))"
                  role="button"
                  [innerHTML]="$safeNavigationMigration(block.variables?.ZigZagHaacCtaText)"
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
